import { exportOnFarmTransaction } from '../api/onFarmTransactionApi';
import { showToast } from './toast.service';
import { toastMessages } from '../constants/errorMessages';
import { TransactionTypeEnum } from '../types/enums/transaction.enum';
import { OnFarmTransactionExportRequest } from '../types/interfaces/onFarmTransaction.interfaces';

const formatFileDateTime = (date: Date) => {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${pad(date.getMonth() + 1)}-${pad(date.getDate())}-${date.getFullYear()}_${pad(date.getHours())}-${pad(
    date.getMinutes(),
  )}`;
};

const getExcelFileName = (transactionType: TransactionTypeEnum) => {
  return `OnFarm_${transactionType}_Transaction_${formatFileDateTime(new Date())}.xlsx`;
};

const downloadExcelResponse = (data: Blob, fileName: string, contentType?: string) => {
  const blob = new Blob([data], {
    type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();

  window.setTimeout(() => {
    link.remove();
    window.URL.revokeObjectURL(url);
  }, 1000);
};

export const downloadOnFarmTransactionExport = async (
  payload: OnFarmTransactionExportRequest,
  transactionType: TransactionTypeEnum,
) => {
  if (!payload.onFarmTransactionId) return;

  try {
    const response = await exportOnFarmTransaction(payload);
    downloadExcelResponse(response.data, getExcelFileName(transactionType), response.headers['content-type']);
    await new Promise(resolve => setTimeout(resolve, 300));
  } catch {
    showToast.error(toastMessages.FAILED_TO_DOWNLOAD_REPORT);
  }
};
